export function WelcomePanel() {
    return (
        <div className="row justify-content-center align-items-center bg-success text-light p-3" style={{height: '90px'}}>
            <div className="col-12 col-sm-12 col-md-10 col-lg-8 text-center">
                <h1>Welcome to VPN Shop Website</h1>
            </div>
        </div>
    );
}
